import {
  differenceInCalendarDays,
  format,
  formatDistanceStrict,
} from 'date-fns';

export function getLocalDayKey(date: Date): string {
  return format(date, 'yyyy-MM-dd');
}

export function formatChatMessageTimestamp(
  date: Date,
  now: Date = new Date()
): string {
  const millisecondsAgo = now.getTime() - date.getTime();
  if (millisecondsAgo < 0) {
    return formatDistanceStrict(date, now, { addSuffix: true });
  }
  if (millisecondsAgo < 60 * 1000) {
    return 'Just now';
  }
  if (differenceInCalendarDays(now, date) >= 7) {
    return format(
      date,
      date.getFullYear() === now.getFullYear() ? 'MMM d' : 'MMM d, yyyy'
    );
  }
  return formatDistanceStrict(date, now, { addSuffix: true });
}

export function formatChatDayLabel(date: Date, now: Date = new Date()): string {
  const calendarDaysAgo = differenceInCalendarDays(now, date);
  if (calendarDaysAgo === 0) {
    return 'Today';
  }
  if (calendarDaysAgo === 1) {
    return 'Yesterday';
  }
  return format(
    date,
    date.getFullYear() === now.getFullYear() ? 'MMMM d' : 'MMMM d, yyyy'
  );
}

export function getChatThreadGroupLabel(
  date: Date,
  now: Date = new Date()
): string {
  const calendarDaysAgo = differenceInCalendarDays(now, date);
  if (calendarDaysAgo <= 0) return 'Today';
  if (calendarDaysAgo === 1) return 'Yesterday';
  if (calendarDaysAgo <= 7) return 'Previous 7 days';
  if (calendarDaysAgo <= 30) return 'Previous 30 days';
  return 'Older';
}

export function formatChatDayDetail(date: Date): string {
  return format(date, 'MMMM d, yyyy');
}

export const COLLAPSE_TIMESTAMP_WITHIN_MINUTES = 5;

export function shouldCollapseChatTimestamp(
  date: Date,
  nextTimestamp?: Date
): boolean {
  if (!nextTimestamp) return false;
  if (getLocalDayKey(date) !== getLocalDayKey(nextTimestamp)) return false;
  const millisecondsUntilNext = nextTimestamp.getTime() - date.getTime();
  return (
    millisecondsUntilNext >= 0 &&
    millisecondsUntilNext <= COLLAPSE_TIMESTAMP_WITHIN_MINUTES * 60 * 1000
  );
}
